export default __webpack_public_path__ + "static/media/emptyBox.c3d6039d.svg";